module.exports = __webpack_public_path__ + "static/media/stil-D4jRahaUaIc-unsplash.ea14dee6.jpg";